import { createContext, type Dispatch, type SetStateAction, useContext } from "react";

type Context = {
    isLoading: boolean;
    setIsLoading: Dispatch<SetStateAction<boolean>>;
    isFullscreen: boolean;
    toggleFullscreen: () => void;
    temporaryEndpoint: string;
    isOnline: boolean;
    storyPermalink: string | null;
}

export const ConfigContext = createContext<Context>({} as Context);

export const useConfig = () => useContext(ConfigContext);
